<template>
  <div :class="'row ' + (isEdit ? 'editing' : '')">
    <div class="col-md-12">
      <div class="form-event" v-if="formIndex == 4">
        <div class="left-navigation">
          <h4>{{ isEdit ? rawEvent.name : "New Event" }}</h4>
          <ul>
            <li @click="onChangeStep(1)"><InforCircleIcon />Event Details</li>
            <li @click="onChangeStep(2)"><SettingIcon />Event Setup</li>
            <li @click="onChangeStep(3)"><BrandingIcon />Branding</li>
            <li @click="onChangeStep(4)" class="active">
              <KeyIcon />Owner & Permissions
            </li>
          </ul>
        </div>
        <div class="right-panel-event">
          <button
            type="button"
            class="close-button-md"
            @click="handleClose()"
            v-if="!isPage"
          >
            <i class="now-ui-icons ui-1_simple-remove"></i>
          </button>
          <div class="row">
            <div class="col-md-12">
              <h3><KeyIcon />Owner & Permissions</h3>
              <div class="row">
                <div class="col-12">
                  <div class="search-table">
                    <div class="wrap-event-input">
                      <label>
                        <strong class="me-2">Search User</strong>
                      </label>

                      <el-input
                        placeholder="Search by Name, Phone, Email or Type"
                        v-model="filters[0].value"
                      >
                        <i
                          slot="prefix"
                          class="el-input__icon el-icon-search"
                        ></i>
                      </el-input>
                    </div>
                  </div>
                  <data-tables-server
                    class="event-table create-event-table"
                    :data="users"
                    :filters="filters"
                    @query-change="loadData"
                    :total="total"
                    :current-page.sync="currentPage"
                    :page-size="pageSize"
                    :pagination-props="{ pageSizes: [10, 100, 500, 1000] }"
                  >
                    <el-table-column
                      v-for="(title, index) in titles"
                      :label="title.label"
                      :key="index"
                      :prop="title.prop"
                      sortable="custom"
                      :formatter="title.formatter"
                      v-if="title.prop !== 'type'"
                    >
                    </el-table-column>

                    <el-table-column
                      v-for="(title, index) in titles"
                      :label="title.label"
                      :key="index"
                      :prop="title.prop"
                      sortable="custom"
                      :formatter="title.formatter"
                      v-if="title.prop === 'type'"
                    >
                      <template slot-scope="scope">
                        <div
                          :class="
                            scope.row.type === 'user'
                              ? 'tag azul'
                              : 'tag purple'
                          "
                          disable-transitions
                        >
                          {{ scope.row.type }}
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column :label="'Permission'">
                      <template slot-scope="scope">
                        <div :class="'action-create-event'" disable-transitions>
                          <el-select v-model="value" placeholder="Select">
                            <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>

                          <!-- <el-dropdown>
                            <span class="el-dropdown-link">
                              <img
                                class="dropdown-dot"
                                src="assets/imgs/dot-dropdown.svg"
                                alt=""
                              />
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item
                                command="a"
                                @click.native="onClickTransationView(scope.row)"
                                ><i class="el-icon-view"></i>
                                View</el-dropdown-item
                              >
                              <el-dropdown-item command="b"
                                ><i class="el-icon-edit-outline"></i>
                                Edit</el-dropdown-item
                              >
                              <el-dropdown-item command="c"
                                ><i class="el-icon-refresh-left"></i>
                                Reload</el-dropdown-item
                              >
                            </el-dropdown-menu>
                          </el-dropdown> -->
                        </div>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                </div>
              </div>

              <div class="form-navigation text-right mt-2">
                <!-- <div>Step 4 of 4</div> -->
                <div>
                  <n-button type="primary" @click.native="formIndex = 3">
                    Back
                  </n-button>
                  <n-button type="primary" @click.native="complete">
                    Save
                  </n-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-event" v-if="formIndex == 3">
        <div class="left-navigation">
          <h4>{{ isEdit ? rawEvent.name : "New Event" }}</h4>
          <ul>
            <li @click="onChangeStep(1)"><InforCircleIcon />Event Details</li>
            <li @click="onChangeStep(2)"><SettingIcon />Event Setup</li>
            <li @click="onChangeStep(3)" class="active">
              <BrandingIcon />Branding
            </li>
            <li @click="onChangeStep(4)"><KeyIcon />Owner & Permissions</li>
          </ul>
        </div>
        <div class="right-panel-event">
          <button
            type="button"
            class="close-button-md"
            @click="handleClose()"
            v-if="!isPage"
          >
            <i class="now-ui-icons ui-1_simple-remove"></i>
          </button>
          <div class="row">
            <div class="col-md-12">
              <h3><BrandingIcon width="15px" height="15px" />Branding</h3>
              <div class="row">
                <div class="col-12 col-lg-4">
                  <div class="row">
                    <div class="col-12">
                      <div class="wrap-event-input">
                        <label>
                          <strong class="me-2">Upload Logo</strong>
                          <InformationIcon />
                        </label>
                        <div class="input-file flex-list">
                          <input
                            class="input-file__input"
                            ref="file"
                            type="file"
                            v-on:change="onUploadLogo"
                          />
                          <div
                            class="input-file__button"
                            @click="$refs.file.click()"
                          >
                            Upload
                          </div>
                          <div
                            v-if="previewLogo"
                            class="btn btn-danger m-0"
                            style="white-space: nowrap"
                            @click="
                              previewLogo = null;
                              rawEvent.logo = null;
                            "
                          >
                            Remove
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="wrap-event-input">
                        <label>
                          <strong class="me-2">Upload Background </strong>
                          <InformationIcon />
                        </label>
                        <div class="input-file flex-list">
                          <input
                            class="input-file__input"
                            ref="file2"
                            type="file"
                            v-on:change="onUploadBackground"
                          />
                          <div
                            class="input-file__button"
                            @click="$refs.file2.click()"
                          >
                            Upload
                          </div>

                          <div
                            v-if="previewBg"
                            class="btn btn-danger m-0"
                            style="white-space: nowrap"
                            @click="
                              previewBg = null;
                              rawEvent.image = null;
                            "
                          >
                            Remove
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-8">
                  <svg
                    style="
                      max-width: calc(50% - 11px);
                      box-shadow: 4px 6px 10px 0 rgba(0, 0, 0, 0.12);
                      border-radius: 17px;
                      margin-right: 20px;
                    "
                    width="184px"
                    height="400px"
                    viewBox="0 0 184 400"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <defs>
                      <rect
                        id="path-_7cmtq5h4_-1"
                        x="0"
                        y="0"
                        width="184"
                        height="400"
                        rx="17"
                      ></rect>
                      <filter
                        x="-7.6%"
                        y="-3.0%"
                        width="119.6%"
                        height="109.0%"
                        filterUnits="objectBoundingBox"
                        id="filter-_7cmtq5h4_-3"
                      >
                        <feOffset
                          dx="4"
                          dy="6"
                          in="SourceAlpha"
                          result="shadowOffsetOuter1"
                        ></feOffset>
                        <feGaussianBlur
                          stdDeviation="5"
                          in="shadowOffsetOuter1"
                          result="shadowBlurOuter1"
                        ></feGaussianBlur>
                        <feColorMatrix
                          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0"
                          type="matrix"
                          in="shadowBlurOuter1"
                        ></feColorMatrix>
                      </filter>
                      <linearGradient
                        x1="50%"
                        y1="0%"
                        x2="50%"
                        y2="99.3005701%"
                        id="linearGradient-_7cmtq5h4_-4"
                      >
                        <stop
                          stop-color="#000000"
                          stop-opacity="0.05"
                          offset="0%"
                        ></stop>
                        <stop
                          stop-color="#000000"
                          stop-opacity="0.4"
                          offset="100%"
                        ></stop>
                      </linearGradient>
                    </defs>
                    <g
                      id="🎪-Events-"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="New-Event---Branding"
                        transform="translate(-761, -212)"
                      >
                        <g id="Group-7" transform="translate(250, 134)">
                          <g id="Group-3" transform="translate(511, 78)">
                            <mask id="mask-_7cmtq5h4_-2" fill="white">
                              <use xlink:href="#path-_7cmtq5h4_-1"></use>
                            </mask>
                            <g id="Rectangle">
                              <use
                                fill="black"
                                fill-opacity="1"
                                filter="url(#filter-_7cmtq5h4_-3)"
                                xlink:href="#path-_7cmtq5h4_-1"
                              ></use>
                              <use
                                fill="#D8D8D8"
                                fill-rule="evenodd"
                                xlink:href="#path-_7cmtq5h4_-1"
                              ></use>
                            </g>
                            <BackgroundPhone2 />

                            <g
                              id="Discover-Events"
                              mask="url(#mask-_7cmtq5h4_-2)"
                            >
                              <g transform="translate(6, 73)">
                                <rect
                                  id="Festival-Image"
                                  fill="#E4EBFA"
                                  fill-rule="evenodd"
                                  x="0"
                                  y="0"
                                  width="170.814"
                                  height="109.56"
                                  rx="7.47"
                                  v-if="!previewBg"
                                ></rect>
                                <rect
                                  id="Overlay"
                                  fill="url(#linearGradient-_7cmtq5h4_-4)"
                                  fill-rule="evenodd"
                                  x="8.25650659e-14"
                                  y="0"
                                  width="170.814"
                                  height="109.56"
                                  rx="7.47"
                                ></rect>
                                <image
                                  v-if="previewBg"
                                  id="event-logos"
                                  x="8.25650659e-14"
                                  y="0"
                                  width="170.814"
                                  height="109.56"
                                  :xlink:href="previewBg"
                                ></image>

                                <text
                                  id="Festival-Name"
                                  fill="none"
                                  font-family="Inter, sans-serif"
                                  font-size="12.948"
                                  font-weight="500"
                                  line-spacing="14.94"
                                >
                                  <tspan x="7.5" y="78.122" fill="#FFFFFF">
                                    Event Name
                                  </tspan>
                                </text>
                                <text
                                  id="Festival-Location"
                                  fill="none"
                                  font-family="Inter, sans-serif"
                                  font-size="6.972"
                                  font-weight="normal"
                                  line-spacing="6.972"
                                  letter-spacing="0.0840741094"
                                >
                                  <tspan x="7.968" y="91.162" fill="#FFFFFF">
                                    Event Location
                                  </tspan>
                                </text>
                                <text
                                  id="Festival-Date"
                                  fill="none"
                                  font-family="Inter, sans-serif"
                                  font-size="6.972"
                                  font-weight="normal"
                                  line-spacing="7.968"
                                  letter-spacing="0.0840741094"
                                >
                                  <tspan x="7.968" y="101.122" fill="#FFFFFF">
                                    Event - Date
                                  </tspan>
                                </text>
                                <g
                                  id="Logo-Blue"
                                  stroke-width="1"
                                  fill="none"
                                  fill-rule="evenodd"
                                  transform="translate(7.968, 7.968)"
                                >
                                  <image
                                    v-if="previewLogo"
                                    id="event-logos"
                                    x="0"
                                    y="-1"
                                    width="28.46"
                                    height="24.9"
                                    :xlink:href="previewLogo"
                                  ></image>

                                  <path
                                    v-if="!previewLogo"
                                    d="M22.6381337,16.82454 C22.7348224,17.1638452 22.8349643,17.4964973 22.9247466,17.832476 C23.014529,18.1651282 23.138843,18.4944538 23.1630152,18.8304325 C23.2079064,19.4990633 22.7866199,20.0313068 22.1201585,20.2209185 C21.429525,20.4138568 20.7388914,20.5934889 20.0482579,20.7797742 C19.1849659,21.0093041 18.321674,21.2388341 17.458382,21.4716906 C16.1634441,21.8176489 14.8719593,22.1702602 13.5770214,22.5128919 C12.6204939,22.7690341 11.6605133,23.0151967 10.7039858,23.2713388 C9.79580268,23.5141749 8.89107272,23.763664 7.98634276,24.0065001 C7.15758249,24.2293771 6.32536905,24.445601 5.49660878,24.6651514 C5.27560604,24.7250288 5.0546033,24.7815796 4.83360056,24.8447835 C4.08771632,25.0576809 3.27622189,24.6352127 3.06903182,23.916684 C2.69263653,22.6226671 2.32314758,21.3253237 1.95020546,20.0279803 C1.570357,18.7106777 1.19050854,17.3967017 0.807206917,16.0793991 C0.555125669,15.211177 0.285778581,14.3462814 0.0578695063,13.4714062 C-0.159680065,12.6264697 0.244340567,11.9279002 1.13180469,11.6983702 C2.084879,11.4522076 3.03450014,11.1894124 3.98757446,10.9332702 C4.70583336,10.740332 5.42754543,10.5507202 6.14925749,10.3611085 C6.29429054,10.3245168 6.37716657,10.2646394 6.41169825,10.1049663 C6.53946545,9.46960071 6.68795167,8.8375616 6.82607838,8.2055225 C6.94693925,7.65997296 7.06434696,7.11109689 7.18175466,6.56554735 C7.21628634,6.39922127 7.26117752,6.37926214 7.47527393,6.42250692 C7.92418574,6.512323 8.37309755,6.60546561 8.82200937,6.69860821 C9.80270902,6.90152603 10.7868618,7.10444385 11.7675615,7.30736167 C12.7309953,7.50695296 13.6978823,7.69656469 14.6613161,7.90613555 C14.9928202,7.97931903 15.2932458,7.91944164 15.6074841,7.83295208 C16.5087609,7.58346296 17.4100377,7.34062688 18.3113145,7.10444385 C19.1400747,6.88821994 19.8997716,7.31401471 20.1276807,8.11237989 C20.2036504,8.37850162 20.2796201,8.64462335 20.3521366,8.9140716 C20.379762,9.01054073 20.4246532,9.06709159 20.545514,9.09037724 C21.4226186,9.26002985 22.2997233,9.44298853 23.1733747,9.6226207 C24.0504793,9.80225287 24.9241308,9.97855851 25.8012354,10.1581907 C26.2846789,10.2579863 26.7646692,10.364435 27.2481127,10.4642307 C27.3724268,10.4908428 27.4069584,10.5507202 27.3827863,10.663822 C27.2066747,11.4522076 27.0305631,12.2439197 26.8579048,13.0323053 C26.7439502,13.5578958 26.6334488,14.0834862 26.5194943,14.6090766 C26.4055398,15.1379935 26.2984916,15.6735635 26.163818,16.1991539 C25.9738938,16.9409682 25.1589462,17.3567834 24.3612644,17.1638452 C23.8156639,17.0307843 23.2631571,16.9343152 22.7106502,16.82454 C22.6899312,16.8079074 22.6726654,16.8145604 22.6381337,16.82454 Z M21.9785787,18.9069425 C21.9682192,18.8969629 21.9578597,18.8836568 21.9475001,18.8736773 C21.9405938,18.8304325 21.9405938,18.7838612 21.9267811,18.7439429 C21.7990139,18.2948625 21.6712467,17.8491086 21.5434795,17.4000282 C21.2499603,16.3821126 20.9529878,15.364197 20.6594686,14.3462814 C20.5213419,13.8672623 20.379762,13.3882432 20.2416353,12.909224 C20.2105567,12.7994488 20.1587592,12.7695101 20.0413515,12.8094284 C19.844521,12.8726323 19.6442372,12.9158771 19.4439535,12.9691014 C18.4528943,13.2318966 17.4618352,13.4980184 16.4742292,13.7608136 C15.6834538,13.9703844 14.8926783,14.1799553 14.1019029,14.3928527 C13.3870972,14.5857909 12.6791978,14.7853822 11.9643921,14.974994 C11.1356318,15.1978709 10.3034183,15.4140948 9.47465808,15.6336452 C8.53539644,15.8831344 7.59268163,16.13595 6.65341999,16.3887656 C5.7728622,16.6249487 4.89575759,16.8611317 4.0151998,17.0939882 C3.56283482,17.213743 3.10701667,17.3334978 2.65465169,17.4565791 C2.56141616,17.4831912 2.46818063,17.5064769 2.51307181,17.6461908 C2.63738585,18.055353 2.75134039,18.4678416 2.86874809,18.8770038 C3.06212549,19.5489612 3.25895605,20.2209185 3.44888028,20.8928759 C3.7044147,21.7777306 3.95649595,22.6625854 4.20857719,23.5474401 C4.24656204,23.687154 4.34325074,23.7337253 4.48137745,23.7137662 C4.55389397,23.7037866 4.62986366,23.687154 4.69892702,23.6671949 C5.41373275,23.4775832 6.12853849,23.291298 6.83989105,23.1016862 C8.12792264,22.755728 9.41595423,22.4097697 10.7039858,22.0638115 C11.860797,21.754445 13.0141551,21.4417519 14.1709663,21.1323854 C15.2379951,20.8463046 16.3084771,20.5635502 17.375506,20.2774694 C18.425269,19.9980416 19.4784852,19.7186138 20.5282482,19.4358594 C20.9426283,19.3260842 21.3570085,19.216309 21.7679354,19.0899012 C21.8542646,19.063289 21.9129685,18.9701464 21.9785787,18.9069425 Z M1.20432121,13.0788766 C1.21122755,13.1088153 1.22158705,13.1686927 1.23885289,13.2285701 C1.39769861,13.7707931 1.55654433,14.3130162 1.71539005,14.8585657 C1.7844534,15.0980753 1.7844534,15.1014018 2.03308148,15.0381979 C2.7927784,14.8386066 3.54902215,14.6323622 4.30526589,14.4327709 C5.86609774,14.0169557 7.42692958,13.6044671 8.98776142,13.1886519 C10.0720561,12.8992445 11.1563508,12.6065106 12.2406455,12.3137767 C13.5183176,11.971145 14.7959896,11.6285132 16.0736617,11.2858815 C17.1648628,10.9931476 18.2526106,10.7037402 19.3438116,10.4176594 C19.475032,10.3843941 19.5061105,10.3311698 19.4681257,10.204762 C19.2920141,9.61929418 19.1297152,9.03382638 18.9570568,8.44835857 C18.8948998,8.23546119 18.794758,8.18223685 18.5737552,8.24211424 C18.0316079,8.38515466 17.4894605,8.53152161 16.9473132,8.67788857 C15.7628766,8.99390812 14.5818932,9.31325419 13.3974567,9.62927374 C12.4892736,9.87210982 11.5845436,10.1149459 10.6763605,10.357782 C9.81997486,10.587312 8.96358925,10.816842 8.10375047,11.0463719 C7.51325877,11.2027185 6.91931391,11.359065 6.32882222,11.518738 C5.20999585,11.818125 4.09462266,12.1208384 2.97924946,12.4202254 C2.45436796,12.5599393 1.92948645,12.7029797 1.40460495,12.8426936 C1.28374407,12.8626527 1.20432121,12.9192036 1.20432121,13.0788766 Z M25.5733263,12.060961 C25.5836858,11.7050232 25.4490123,11.5253911 25.1451335,11.4621871 C24.5684545,11.3424324 23.9883223,11.2226776 23.4081901,11.1162289 C22.7348224,10.9931476 22.6519464,11.0363924 22.4931007,11.6617784 C22.3480676,12.2306136 22.2306599,12.8061019 22.1167054,13.3815901 C22.0510952,13.7142423 22.2341131,13.9437723 22.5794299,13.9969966 C22.6174147,14.0036496 22.6588527,14.0103027 22.6968376,14.0169557 C23.3045951,14.140037 23.9088995,14.2730979 24.516657,14.3861996 C24.8654269,14.4494035 25.0864297,14.2830775 25.1589462,13.9437723 C25.2280096,13.6244262 25.3074324,13.3084066 25.3764958,12.9890606 C25.4524655,12.6597349 25.5180756,12.3270828 25.5733263,12.060961 Z"
                                    id="Shape"
                                    fill="#2D61D3"
                                    fill-rule="nonzero"
                                  ></path>
                                  <path
                                    v-if="!previewLogo"
                                    d="M28.455857,5.10275051 C28.3910937,5.55383335 28.3263303,6.00149889 28.2581583,6.45258173 C28.2138465,6.73963444 28.1524917,7.02326986 28.1218143,7.31032258 C28.1047713,7.48118729 28.0161477,7.48460458 27.8900295,7.45726623 C27.4298686,7.3581647 26.9697077,7.25906316 26.5095468,7.16337892 C25.3301714,6.91391645 24.1473874,6.66787126 22.9646034,6.41840879 C22.1056363,6.23729219 21.2466692,6.0561756 20.3877022,5.87164171 C19.4776061,5.67685594 18.5709187,5.47523558 17.6642312,5.28044981 C16.7541352,5.08908134 15.8440391,4.90454745 14.9339431,4.71317897 C14.2897178,4.5764872 13.6489011,4.42954355 13.0080844,4.29285178 C12.3706763,4.15616002 11.7298596,4.02972013 11.0924515,3.89644566 C10.3459683,3.73583283 9.59607639,3.5718027 8.84959311,3.41118988 C8.66552874,3.37018235 8.48487297,3.32575752 8.3008086,3.29500187 C8.19514202,3.2779154 8.17128183,3.22665599 8.18491622,3.13097175 C8.23263662,2.82341527 8.27353981,2.5124415 8.3212602,2.20488502 C8.36557199,1.91441501 8.42692678,1.623945 8.46101278,1.3300577 C8.55304496,0.533828147 9.09842087,0.0861626052 9.79377516,0.00414754403 C10.0085169,-0.0197735155 10.2403017,0.0656588399 10.4618606,0.110083665 C11.0379139,0.229688962 11.6139673,0.34929426 12.1900206,0.475734146 C12.943321,0.636346974 13.6966215,0.807211685 14.449922,0.964407218 C15.0873301,1.10109899 15.7281468,1.22412158 16.3655549,1.36081335 C17.0200059,1.49750512 17.6710484,1.64444877 18.3254995,1.78455783 C18.9458646,1.9178323 19.5696383,2.04427219 20.1900034,2.17754666 C20.6944761,2.28348279 21.1989489,2.39625349 21.700013,2.50218962 C22.0545073,2.57737009 22.4090017,2.64913327 22.7669046,2.72089645 C23.4281729,2.85758821 24.0860326,2.99769728 24.7473009,3.13780634 C25.5006013,3.29841917 26.2539018,3.459032 27.0072023,3.61281024 C27.4707718,3.70849447 27.9138897,3.83835165 28.2002121,4.25867884 C28.3740507,4.51497591 28.4694914,4.78835945 28.455857,5.10275051 Z"
                                    id="Path"
                                    fill="#2D61D3"
                                    fill-rule="nonzero"
                                  ></path>
                                  <path
                                    v-if="!previewLogo"
                                    d="M7.04478906,18.4971429 C7.35026548,18.4971429 7.54850018,18.6335424 7.63299366,18.9030939 C7.74673488,19.2700737 7.84422735,19.6403011 7.94821932,20.0105284 C8.01321431,20.2443562 8.07495954,20.4781841 8.14320427,20.7120119 C8.26344499,21.1277058 8.09770779,21.4232381 7.67849014,21.540152 C7.11628354,21.6960373 6.55407693,21.8519225 5.99512008,22.0110553 C5.54015519,22.1409596 5.25417727,21.9785792 5.1306868,21.5174188 C4.97144909,20.9296016 4.79921239,20.3417845 4.64647417,19.7539674 C4.55873095,19.4162161 4.73746715,19.1239313 5.07219132,19.0297507 C5.67989441,18.8576274 6.29084725,18.6887518 6.89855034,18.5231237 C6.95704583,18.5003905 7.02204081,18.5003905 7.04478906,18.4971429 Z"
                                    id="Path"
                                    fill="#2D61D3"
                                    fill-rule="nonzero"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>

                  <svg
                    style="
                      max-width: calc(50% - 11px);
                      box-shadow: 4px 6px 10px 0 rgba(0, 0, 0, 0.12);
                      border-radius: 17px;
                    "
                    width="184px"
                    height="400px"
                    viewBox="0 0 184 400"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <defs>
                      <rect
                        id="path-ysbdfocn2s-1"
                        x="0"
                        y="2.27373675e-13"
                        width="184"
                        height="400"
                        rx="17"
                      ></rect>
                      <filter
                        x="-7.6%"
                        y="-3.0%"
                        width="119.6%"
                        height="109.0%"
                        filterUnits="objectBoundingBox"
                        id="filter-ysbdfocn2s-3"
                      >
                        <feOffset
                          dx="4"
                          dy="6"
                          in="SourceAlpha"
                          result="shadowOffsetOuter1"
                        ></feOffset>
                        <feGaussianBlur
                          stdDeviation="5"
                          in="shadowOffsetOuter1"
                          result="shadowBlurOuter1"
                        ></feGaussianBlur>
                        <feColorMatrix
                          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0"
                          type="matrix"
                          in="shadowBlurOuter1"
                        ></feColorMatrix>
                      </filter>
                    </defs>
                    <g
                      id="🎪-Events-"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="New-Event---Branding"
                        transform="translate(-966, -212)"
                      >
                        <g id="Group-7" transform="translate(250, 134)">
                          <g id="Group-6" transform="translate(716, 78)">
                            <mask id="mask-ysbdfocn2s-2" fill="white">
                              <use xlink:href="#path-ysbdfocn2s-1"></use>
                            </mask>
                            <g id="Rectangle">
                              <use
                                fill="black"
                                fill-opacity="1"
                                filter="url(#filter-ysbdfocn2s-3)"
                                xlink:href="#path-ysbdfocn2s-1"
                              ></use>
                              <use
                                fill="#D8D8D8"
                                fill-rule="evenodd"
                                xlink:href="#path-ysbdfocn2s-1"
                              ></use>
                            </g>
                            <g id="Group-5" mask="url(#mask-ysbdfocn2s-2)">
                              <rect
                                id="Festival-Image"
                                fill="#E4EBFA"
                                x="0"
                                y="0"
                                width="184"
                                height="213"
                              ></rect>
                              <image
                                v-if="previewBg"
                                id="event-logos"
                                x="0"
                                y="0"
                                width="100%"
                                height="100%"
                                :xlink:href="previewBg"
                              ></image>

                              <BackgroundPhone />
                              <g
                                id="Logo-Blue"
                                transform="translate(44.6, 54.6)"
                                fill="#2D61D3"
                                fill-rule="nonzero"
                              >
                                <image
                                  v-if="previewLogo"
                                  id="event-logos"
                                  x="0"
                                  y="-1"
                                  width="90"
                                  height="61"
                                  :xlink:href="previewLogo"
                                ></image>
                                <template v-if="!previewLogo">
                                  <path
                                    d="M74.0317626,55.0200102 C74.3479562,56.1296142 74.6754425,57.2174611 74.969051,58.3161866 C75.2626594,59.4040336 75.6691941,60.4810021 75.7482425,61.5797276 C75.8950467,63.7663001 74.5173457,65.5068553 72.3378679,66.126928 C70.0793416,66.7578793 67.8208153,67.3453167 65.5622891,67.954511 C62.7391312,68.7051254 59.9159734,69.4557398 57.0928155,70.2172327 C52.8580788,71.3485936 48.6346347,72.5017114 44.3998979,73.6221938 C41.271839,74.459836 38.1324875,75.2648428 35.0044287,76.102485 C32.0344666,76.8966133 29.0757972,77.7124985 26.1171278,78.5066268 C23.4068963,79.2354843 20.6853721,79.9425849 17.9751406,80.6605639 C17.2524122,80.8563764 16.5296838,81.0413103 15.8069554,81.2480013 C13.367747,81.9442234 10.7139786,80.5626577 10.0364208,78.2129082 C8.80552395,73.9811833 7.59721239,69.7385801 6.37760821,65.4959768 C5.13541876,61.1881027 3.89322931,56.891107 2.63974723,52.5832329 C1.81538515,49.7439523 0.934559902,46.9155501 0.189246234,44.0545125 C-0.52218954,41.2913811 0.799048326,39.0069024 3.70125458,38.256288 C6.81802083,37.4512812 9.92349445,36.5918821 13.0402607,35.7542399 C15.389128,35.1232887 17.749288,34.5032159 20.1094479,33.8831431 C20.5837384,33.7634799 20.8547616,33.5676675 20.9676879,33.0455009 C21.3855153,30.9677132 21.8710984,28.9008039 22.3228037,26.8338946 C22.7180458,25.0498255 23.1019952,23.254878 23.4859447,21.4708089 C23.598871,20.9268854 23.7456752,20.8616146 24.4458183,21.0030347 C25.9138604,21.2967534 27.3819025,21.6013505 28.8499446,21.9059477 C32.0570519,22.5695343 35.2754518,23.233121 38.4825591,23.8967077 C41.6332032,24.5494159 44.79514,25.1694887 47.9457842,25.8548323 C49.0298768,26.0941586 50.0123357,25.8983462 51.0399652,25.6155059 C53.9873419,24.7996207 56.9347187,24.0054924 59.8820955,23.233121 C62.592327,22.5260205 65.0767059,23.9184646 65.8220196,26.5292974 C66.0704575,27.399575 66.3188954,28.2698526 66.5560406,29.1510087 C66.6463817,29.4664843 66.7931859,29.6514183 67.188428,29.7275676 C70.0567563,30.2823695 72.9250847,30.8806854 75.7821204,31.4681228 C78.6504488,32.0555601 81.5074845,32.6321191 84.3758129,33.2195564 C85.9567813,33.5459105 87.526457,33.8940216 89.1074254,34.2203757 C89.5139601,34.3074034 89.6268864,34.5032159 89.547838,34.8730839 C88.9719138,37.4512812 88.3959896,40.0403571 87.8313581,42.6185545 C87.4587012,44.3373527 87.097337,46.056151 86.7246802,47.7749492 C86.3520233,49.504626 86.0019518,51.2560596 85.5615392,52.9748579 C84.9404444,55.4007567 82.2753834,56.7605654 79.6667856,56.1296142 C77.8825498,55.6944754 76.0757288,55.3789997 74.2689078,55.0200102 C74.201152,54.9656179 74.1446889,54.9873748 74.0317626,55.0200102 Z M71.87487,61.8299324 C71.8409921,61.797297 71.8071142,61.7537831 71.7732363,61.7211477 C71.750651,61.5797276 71.750651,61.427429 71.7054805,61.2968874 C71.2876531,59.8282939 70.8698258,58.370579 70.4519984,56.9019855 C69.4921248,53.5731737 68.5209585,50.2443619 67.5610848,46.9155501 C67.1093795,45.3490504 66.6463817,43.7825508 66.1946764,42.2160511 C66.0930427,41.8570616 65.9236533,41.7591553 65.5397038,41.889697 C64.8960238,42.0963879 64.2410512,42.237808 63.5860786,42.4118635 C60.3450934,43.2712627 57.1041082,44.1415403 53.8744156,45.0009394 C51.288403,45.686283 48.7023905,46.3716266 46.1163779,47.0678487 C43.7788032,47.6987999 41.4638138,48.3515081 39.1262391,48.9715809 C36.4160076,49.7004384 33.6944834,50.407539 30.9842519,51.125518 C27.9126562,51.9414032 24.8297678,52.7681669 21.7581721,53.5949307 C18.8785511,54.367302 16.0102227,55.1396734 13.1306017,55.9011663 C11.651267,56.2927912 10.1606397,56.6844161 8.681305,57.0869195 C8.37640395,57.1739473 8.07150291,57.2500966 8.21830712,57.7069923 C8.62484184,59.0450441 8.99749868,60.3939744 9.38144814,61.7320262 C10.0138355,63.9294771 10.6575155,66.126928 11.2786102,68.324379 C12.1142649,71.218052 12.938627,74.111725 13.7629891,77.005398 C13.887208,77.4622937 14.2034017,77.6145923 14.655107,77.5493215 C14.8922522,77.5166861 15.1406901,77.4622937 15.3665428,77.3970229 C17.7041174,76.7769501 20.0416921,76.1677558 22.3679742,75.547683 C26.5801257,74.4163221 30.7922772,73.2849613 35.0044287,72.1536004 C38.7874601,71.1419027 42.559199,70.1193265 46.3422305,69.1076288 C49.8316536,68.1720804 53.3323693,67.2474104 56.8217924,66.311862 C60.2547523,65.3980706 63.6990049,64.4842791 67.1319648,63.5596091 C68.4870806,63.2006196 69.8421963,62.8416301 71.1860195,62.4282483 C71.4683352,62.3412205 71.66031,62.0366233 71.87487,61.8299324 Z M3.93839984,42.7708531 C3.9609851,42.8687593 3.994863,43.0645717 4.05132615,43.2603842 C4.57078719,45.0335748 5.09024823,46.8067654 5.60970928,48.5908345 C5.8355619,49.3740843 5.8355619,49.3849628 6.64863136,49.1782719 C9.13301025,48.5255637 11.6060965,47.8510985 14.0791828,47.1983903 C19.1834521,45.8385816 24.2877215,44.4896513 29.3919909,43.1298426 C32.9378771,42.1834157 36.4837634,41.2261103 40.0296496,40.268805 C44.2079232,39.1483226 48.3861968,38.0278402 52.5644704,36.9073577 C56.1329419,35.9500524 59.6901208,35.0036255 63.2585923,34.0680771 C63.6877123,33.9592924 63.7893459,33.7852369 63.665127,33.371855 C63.0892028,31.4572443 62.5584491,29.5426336 61.9938176,27.6280229 C61.7905502,26.9318008 61.4630639,26.7577453 60.7403355,26.9535577 C58.9673924,27.4213319 57.1944492,27.8999846 55.4215061,28.3786373 C51.5481336,29.4120919 47.6860536,30.4564251 43.8126811,31.4898797 C40.8427191,32.284008 37.8840496,33.0781363 34.9140876,33.8722646 C32.113515,34.6228791 29.3129425,35.3734935 26.5010773,36.1241079 C24.5700373,36.635396 22.6277047,37.1466841 20.6966647,37.6688506 C17.0378522,38.6479129 13.3903323,39.6378537 9.74281235,40.616916 C8.02633238,41.0738117 6.30985242,41.5415859 4.59337246,41.9984817 C4.19813036,42.0637525 3.93839984,42.2486865 3.93839984,42.7708531 Z M83.6304992,39.4420412 C83.6643771,38.278045 83.2239645,37.6906076 82.2302129,37.4839167 C80.3443435,37.0922917 78.4471814,36.7006668 76.5500193,36.3525558 C74.3479562,35.9500524 74.0769331,36.0914725 73.557472,38.1366249 C73.0831815,39.9968432 72.6992321,41.8788185 72.3265752,43.7607938 C72.1120152,44.8486408 72.7105247,45.5992552 73.8397878,45.7733108 C73.9640068,45.7950677 74.0995183,45.8168246 74.2237373,45.8385816 C76.2112404,46.241085 78.1874509,46.6762238 80.174954,47.0460917 C81.3155098,47.2527827 82.0382382,46.7088592 82.2753834,45.5992552 C82.5012361,44.5549221 82.7609666,43.5214675 82.9868192,42.4771344 C83.2352571,41.4001658 83.4498171,40.3123188 83.6304992,39.4420412 Z"
                                    id="Shape"
                                  ></path>
                                  <path
                                    d="M93.0570196,16.6871359 C92.8452288,18.1622777 92.633438,19.6262442 92.4105004,21.101386 C92.2655909,22.0401126 92.064947,22.9676639 91.9646251,23.9063905 C91.9088907,24.4651564 91.6190717,24.4763317 91.206637,24.3869291 C89.7018079,24.062845 88.1969787,23.7387608 86.6921495,23.4258519 C82.835328,22.6100538 78.9673597,21.805431 75.0993914,20.9896329 C72.2903769,20.3973411 69.4813624,19.8050493 66.6723479,19.2015822 C63.6961302,18.5645891 60.7310594,17.9052455 57.7659886,17.2682524 C54.7897709,16.6424347 51.8135531,16.0389676 48.8373354,15.4131498 C46.7305746,14.9661372 44.6349606,14.4855985 42.5393466,14.0385859 C40.4548795,13.5915732 38.3592656,13.1780865 36.2747985,12.7422491 C33.8336312,12.2170092 31.3813169,11.680594 28.9401496,11.1553542 C28.3382179,11.0212504 27.7474331,10.8759712 27.1455015,10.7753934 C26.7999481,10.7195168 26.7219199,10.5518871 26.7665074,10.2389782 C26.9225638,9.23319968 27.0563264,8.21624586 27.2123828,7.21046736 C27.3572922,6.26056544 27.5579361,5.31066352 27.669405,4.34958628 C27.9703708,1.74573749 29.753872,0.281770998 32.0278361,0.013563397 C32.7300898,-0.06466382 33.4880778,0.214719098 34.2126252,0.359998215 C36.0964484,0.7511343 37.9802716,1.14227038 39.8640948,1.5557571 C42.3275559,2.08099699 44.791017,2.63976282 47.2544781,3.15382739 C49.3389452,3.60084006 51.4345591,4.00315146 53.5190262,4.45016413 C55.6592277,4.8971768 57.7882823,5.37771542 59.9284838,5.8359034 C61.9572165,6.27174075 63.9970961,6.68522747 66.0258287,7.12106482 C67.6755674,7.46749964 69.3253061,7.83628509 70.9638978,8.18271991 C72.1231736,8.42857688 73.2824495,8.66325853 74.4528722,8.89794018 C76.6153674,9.34495285 78.7667158,9.80314084 80.9292111,10.2613288 C83.3926722,10.7865687 85.8561333,11.3118086 88.3195944,11.8146978 C89.8355705,12.1276067 91.2846652,12.5522687 92.2210034,13.9268327 C92.7894944,14.7649815 93.1016071,15.6590068 93.0570196,16.6871359 Z"
                                    id="Path"
                                  ></path>
                                  <path
                                    d="M23.0380365,60.4897959 C24.0370128,60.4897959 24.6852846,60.935853 24.9615972,61.8173467 C25.3335564,63.0174527 25.6523786,64.228179 25.9924556,65.4389054 C26.2050038,66.2035746 26.4069245,66.9682439 26.6301,67.7329132 C27.0233141,69.0923252 26.4813163,70.0587822 25.1103808,70.4411168 C23.2718395,70.9508964 21.4332981,71.4606759 19.6053841,71.9810758 C18.1175471,72.4058921 17.1823353,71.8748717 16.7784938,70.366774 C16.2577509,68.4444804 15.6944983,66.5221868 15.1950102,64.5998932 C14.9080702,63.495371 15.4925776,62.5395344 16.5872005,62.2315426 C18.5745256,61.668661 20.5724781,61.1163999 22.5598032,60.5747592 C22.7510965,60.5004163 22.9636447,60.5004163 23.0380365,60.4897959 Z"
                                    id="Path"
                                  ></path>
                                </template>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>

              <div class="form-navigation text-right mt-3">
                <!-- <div>Step 3 of 4</div> -->
                <div v-if="!isEdit">
                  <n-button type="default" @click.native="formIndex = 2">
                    Back
                  </n-button>
                  <n-button type="primary" @click.native="formIndex = 4">
                    Next
                  </n-button>
                </div>
                <div v-if="isEdit">
                  <n-button type="primary" @click.native="onUpdateEvent()">
                    Save
                  </n-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-event" v-if="formIndex == 2">
        <div class="left-navigation">
          <h4>{{ isEdit ? rawEvent.name : "New Event" }}</h4>
          <ul>
            <li @click="onChangeStep(1)"><InforCircleIcon />Event Details</li>
            <li @click="onChangeStep(2)" class="active">
              <SettingIcon />Event Setup
            </li>
            <li @click="onChangeStep(3)"><BrandingIcon />Branding</li>
            <li @click="onChangeStep(4)"><KeyIcon />Owner & Permissions</li>
          </ul>
        </div>
        <div class="right-panel-event">
          <button
            type="button"
            class="close-button-md"
            @click="handleClose()"
            v-if="!isPage"
          >
            <i class="now-ui-icons ui-1_simple-remove"></i>
          </button>
          <div class="row">
            <div class="col-md-12">
              <h3><TokenIcon />Token Details</h3>
              <div class="row">
                <div class="col-12 col-md-6 col-xl-3">
                  <div class="wrap-event-input">
                    <label>
                      <strong>Token Symbol</strong>
                    </label>
                    <fg-input
                      v-model="rawEvent.token_symbol"
                      name="token_symbol"
                      :error="getError('token_symbol')"
                      placeholder="TACO"
                      v-validate="'required'"
                    >
                    </fg-input>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-xl-3">
                  <div class="wrap-event-input">
                    <label>
                      <strong>Token Value</strong>
                    </label>
                    <fg-input
                      v-model="rawEvent.tokenValue"
                      name="tokenValue"
                      :error="getError('tokenValue')"
                      placeholder="2.00"
                      v-validate="'required'"
                      addonLeftIcon="dollar-icon"
                    >
                    </fg-input>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-xl-3">
                  <div class="wrap-event-input">
                    <label>
                      <strong>Currency</strong>
                    </label>
                    <fg-input
                      placeholder="CAD"
                      name="currency"
                      :error="getError('currency')"
                      v-validate="'required|max:3'"
                      v-model="rawEvent.currency"
                    ></fg-input>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-xl-3">
                  <label for=""></label>
                  <div>
                    <label class="hint-label">Token Conversion</label>
                    <span class="hint-small">
                      1 {{ rawEvent.token_symbol || "Beer Fest Token" }} =
                      {{ parseFloat(rawEvent.tokenValue || 2).toFixed(2) }}
                      {{ rawEvent.currency || "CAD" }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6 col-xl-3">
                  <div class="wrap-event-input">
                    <label>
                      <strong class="me-2">Reload Amounts</strong>
                      <InformationIcon />
                    </label>
                    <fg-input
                      v-model="rawEvent.topup_amounts"
                      name="topup_amounts"
                      :error="getError('topup_amounts')"
                      placeholder="5,10,15,20"
                      v-validate="'required'"
                    >
                    </fg-input>
                  </div>
                </div>
              </div>

              <div class="form-navigation text-right">
                <!-- <div>Step 2 of 4</div> -->
                <div v-if="!isEdit">
                  <n-button type="default" @click.native="formIndex = 1">
                    Back
                  </n-button>
                  <n-button type="primary" @click.native="onNext(3)">
                    Next
                  </n-button>
                </div>
                <div v-if="isEdit">
                  <n-button type="primary" @click.native="onUpdateEvent()">
                    Save
                  </n-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-event" v-if="formIndex == 1">
        <div class="left-navigation">
          <h4>{{ isEdit ? rawEvent.name : "New Event" }}</h4>
          <ul>
            <li @click="onChangeStep(1)" class="active">
              <InforCircleIcon />Event Details
            </li>
            <li @click="onChangeStep(2)"><SettingIcon />Event Setup</li>
            <li @click="onChangeStep(3)"><BrandingIcon />Branding</li>
            <li @click="onChangeStep(4)"><KeyIcon />Owner & Permissions</li>
          </ul>
        </div>
        <div class="right-panel-event">
          <button
            type="button"
            class="close-button-md"
            @click="handleClose()"
            v-if="!isPage"
          >
            <i class="now-ui-icons ui-1_simple-remove"></i>
          </button>
          <div class="row">
            <div class="col-md-12">
              <h3><InforCircleIcon />Event Details</h3>
              <div class="wrap-event-input">
                <label>
                  <strong>Event Name</strong>
                </label>
                <fg-input
                  v-model="rawEvent.name"
                  name="name"
                  :error="getError('name')"
                  placeholder="Event Name"
                  v-validate="'required'"
                ></fg-input>
              </div>

              <div class="wrap-event-input">
                <label>
                  <strong>Description</strong>
                </label>
                <fg-input
                  v-model="rawEvent.description"
                  placeholder="Event Description"
                ></fg-input>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="wrap-event-input">
                    <label>
                      <strong>Event Start Date</strong>
                    </label>
                    <fg-input>
                      <el-date-picker
                        :editable="false"
                        v-model="rawEvent.start_date_time"
                        placeholder="Event Start Date..."
                        type="datetime"
                        :format="'MMM dd, yyyy HH:mm'"
                      >
                      </el-date-picker>
                    </fg-input>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="wrap-event-input">
                    <label>
                      <strong>Event End Date</strong>
                    </label>
                    <fg-input>
                      <el-date-picker
                        :editable="false"
                        v-model="rawEvent.end_date_time"
                        placeholder="Event End Date..."
                        type="datetime"
                        :format="'MMM dd, yyyy HH:mm'"
                        :disabled="!rawEvent.start_date_time"
                        :picker-options="pickerOptions"
                      >
                      </el-date-picker>
                    </fg-input>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="wrap-event-input">
                    <label>
                      <strong>Event Publish Date</strong>
                    </label>
                    <fg-input>
                      <el-date-picker
                        :editable="false"
                        v-model="rawEvent.publish_start_date_time"
                        placeholder="Event Publish Date..."
                        type="datetime"
                        :format="'MMM dd yyyy HH:mm'"
                      >
                      </el-date-picker>
                    </fg-input>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="wrap-event-input">
                    <label>
                      <strong>Event Unpublish Date</strong>
                    </label>
                    <fg-input>
                      <el-date-picker
                        :editable="false"
                        v-model="rawEvent.publish_end_date_time"
                        placeholder="Event Unpublish Date..."
                        type="datetime"
                        :format="'MMM dd, yyyy HH:mm'"
                        :disabled="!rawEvent.publish_start_date_time"
                        :picker-options="pickerOptionsPublish"
                      >
                      </el-date-picker>
                    </fg-input>
                  </div>
                </div>
              </div>

              <!-- <div class="event-branding wrap-event-input">
                <label>
                  <strong>Event Branding</strong>
                  <small>
                    Upload an image that will be used to market your event.
                    Image should be 1920px by 1080px
                  </small></label
                >
                <preview-upload v-model="rawEvent.image"></preview-upload>
              </div> -->
              <div class="location wrap-event-input">
                <div class="row">
                  <!-- <div class="col-12 col-md-4">
                    <div class="wrap-event-input">
                      <label>
                        <strong>Phone</strong>
                      </label>
                      <fg-input
                        placeholder="Phone..."
                        name="phone"
                        v-model="rawEvent.phone"
                        :error="getError('phone')"
                        v-validate="{
                          required: true,
                          regex: /^\+?[0-9]{3}-?[0-9]{7,11}$/,
                        }"
                      ></fg-input>
                    </div>
                  </div> -->

                  <div class="col-12 col-md-6">
                    <div class="wrap-event-input">
                      <label>
                        <strong>Email</strong>
                      </label>
                      <fg-input
                        placeholder="Email..."
                        name="email"
                        v-model="rawEvent.email"
                        :error="getError('email')"
                        v-validate="'required|email'"
                      ></fg-input>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="wrap-event-input">
                      <label>
                        <strong>Website URL</strong>
                      </label>
                      <fg-input
                        placeholder="URL"
                        v-model="rawEvent.website"
                        name="website"
                        :error="getError('website')"
                        v-validate="'url'"
                      ></fg-input>
                    </div>
                  </div>
                  <div class="col-12 col-md-8">
                    <div class="wrap-event-input">
                      <label>
                        <strong>Event Address</strong>
                      </label>
                      <fg-input
                        placeholder="Event Address..."
                        name="address"
                        v-model="rawEvent.address"
                        :error="getError('address')"
                        v-validate="'required'"
                      ></fg-input>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="wrap-event-input">
                      <label>
                        <strong>City</strong>
                      </label>
                      <fg-input
                        placeholder="City"
                        name="city"
                        v-model="rawEvent.city"
                      ></fg-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-navigation text-right">
                <!-- <div>Step 1 of 4</div> -->
                <div v-if="!isEdit">
                  <n-button type="primary" @click.native="onNext(2)">
                    Next
                  </n-button>
                </div>
                <div v-if="isEdit">
                  <n-button type="primary" @click.native="onUpdateEvent()">
                    Save
                  </n-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Radio } from "src/components";
import PreviewUpload from "../Components/PreviewUpload";
import { DatePicker, TimeSelect } from "element-ui";
import { humanize } from "src/util/string";
import GetError from "src/mixins/GetError.js";
import User from "src/mixins/User.js";

import InforCircleIcon from "src/components/Icons/InforCircle";
import SettingIcon from "src/components/Icons/Setting";
import KeyIcon from "src/components/Icons/Key";
import BrandingIcon from "src/components/Icons/Branding";
import TokenIcon from "src/components/Icons/Token";
import InformationIcon from "src/components/Icons/Information";
import MapIcon from "src/components/Icons/Map";
import BackgroundPhone from "./backgroundPhone.vue";
import BackgroundPhone2 from "./backgroundPhone2.vue";

import moment from "moment/moment";
const compact = (list) => list.filter((x) => !!x);

import _ from "lodash";
const debounced = _.debounce((vm, url, params) => {
  axios.get(url, { params }).then((response) => {
    if (response.data.results) {
      vm.users = response.data.results;
      vm.total = response.data.count;
    } else {
      vm.users = response.data;
      vm.total = vm.users.length;
    }
  });
}, 500);

// TODO:
// - Map the remaining fields to the models
//   - Returns: min_return_ammount, refund_claim_days, return_allowed
//   - min_num_items, max_num_items, add_on?
// - Who can send this API?
// - Split the forms out
export default {
  components: {
    PreviewUpload,
    InforCircleIcon,
    SettingIcon,
    KeyIcon,
    BrandingIcon,
    TokenIcon,
    InformationIcon,
    MapIcon,
    BackgroundPhone,
    BackgroundPhone2,
    [Radio.name]: Radio,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
  },
  props: [
    "onCloseCreateEvent",
    "rawEventEdit",
    "isEdit",
    "origEvent",
    "isPage",
  ],
  computed: {
    event: function () {
      const e = {
        name: this.rawEvent.name,
        description: this.rawEvent.description,
        image: this.rawEvent.image,
        website: this.rawEvent.website,
        address: compact([this.rawEvent.address, this.rawEvent.city]).join(" "),
        currency: this.rawEvent.currency,
        fees_paid_by: this.rawEvent.feesPaidBy,
        token_name: this.rawEvent.tokenName,
        token_value: this.rawEvent.tokenValue,
        token_symbol: this.rawEvent.tokenSymbol,
        min_transactions: this.rawEvent.minTransactions,
        slug: this.rawEvent.slug,
        logo: this.rawEvent.logo,
        email: this.rawEvent.email,
        fee: this.rawEvent.fee / 100,
        phone: this.rawEvent.phone,
        topup_amounts: this.rawEvent.topup_amounts,
        publish_start_date_time: moment(
          this.rawEvent.publish_start_date_time
        ).format("YYYY-MM-DDThh:mm"),
        publish_end_date_time: moment(
          this.rawEvent.publish_end_date_time
        ).format("YYYY-MM-DDThh:mm"),
        start_date_time: moment(this.rawEvent.start_date_time).format(
          "YYYY-MM-DDThh:mm"
        ),
        end_date_time: moment(this.rawEvent.end_date_time).format(
          "YYYY-MM-DDThh:mm"
        ),
      };

      const form = new FormData();

      Object.keys(e).map((k) => {
        if (!!e[k]) {
          form.append(k, e[k]);
        }
      });

      return form;
    },
  },
  methods: {
    handleClose() {
      this.rawEvent = {};
      this.$emit("onClose");
    },
    changed: function (key) {
      if (!this.dirties.includes(key)) {
        this.dirties.push(key);
      }
    },
    eventAsFormData: function () {
      const self = this;
      const e = {
        ...this.rawEvent,
      };

      e.publish_start_date_time = moment(
        this.rawEvent.publish_start_date_time
      ).format("YYYY-MM-DDThh:mm");
      e.publish_end_date_time = moment(
        this.rawEvent.publish_end_date_time
      ).format("YYYY-MM-DDThh:mm");
      e.start_date_time = moment(this.rawEvent.start_date_time).format(
        "YYYY-MM-DDThh:mm"
      );
      e.end_date_time = moment(this.rawEvent.end_date_time).format(
        "YYYY-MM-DDThh:mm"
      );

      if (e.phone[0] !== "+") {
        e.phone = "+" + e.phone;
      }
      console.log(e);
      const form = new FormData();
      const ignores = ["id", "vendor_events"].filter(
        (x) => !this.dirties.includes(x)
      );

      Object.keys(e)
        .filter((x) => !ignores.includes(x))
        .map((k) => {
          if (k === "logo" || k === "image") {
            console.log(e[k], this.origEvent[k]);
            if (e[k] != this.origEvent[k]) {
              form.append(k, e[k] || "");
            }
          } else if (k == "point") {
            form.append(k, `POINT(${e[k].lng} ${e[k].lat})`);
          } else {
            form.append(k, e[k] || "");
          }
        });

      return form;
    },
    onUpdateEvent: function () {
      const self = this;
      const url = `${process.env.VUE_APP_BASE_HOST}/en/api/event/${this.$route.params.id}/`;
      self.successMsg = "";
      this.serverErrors = "";
      const payload = this.eventAsFormData();
      axios
        .patch(url, payload)
        .then((response) => {
          self.$message("Successfully update the event detail");
          this.$store.dispatch("getEvents");
        })
        .catch((e) => {
          if (e.response.status !== 403 || e.response.status != 401) {
            this.serverErrors = humanize(e.response.data);
          } else {
            this.serverErrors = [e.response.data.detail];
          }
          self.$message(humanize(e.response.data).join(" "));
        });
    },
    onChangeStep(step) {
      if (this.isEdit) {
        this.formIndex = step;
      } else {
        this.onNext(step);
      }
    },
    async onNext(step) {
      try {
        switch (step) {
          case 2:
            await this.$validator.validate("name");
            await this.$validator.validate("phone");
            await this.$validator.validate("email");
            await this.$validator.validate("address");
            await this.$validator.validate("website");
            break;
          case 3:
            await this.$validator.validate("topup_amounts");
            await this.$validator.validate("currency");
            await this.$validator.validate("tokenValue");
            await this.$validator.validate("token_symbol");
            break;
          default:
            break;
        }
      } catch (error) {}
      if (this.$validator.errors.items.length === 0) {
        this.formIndex = step;
      }
    },
    async loadData(queryInfo) {
      this.loading = true;

      (queryInfo.type === "page" || queryInfo.type === "size") &&
        this.$message(
          `page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}`
        );
      let url = `${process.env.VUE_APP_BASE_HOST}/en/api/user/`;
      if (this.url) {
        url = this.url;
      }

      let params = {
        offset: (queryInfo.page - 1) * queryInfo.pageSize,
        limit: queryInfo.pageSize,
        search: this.filters[0].value,
        expand: "balance",
      };

      if (this.params) {
        const passed = this.params;
        params = {
          ...params,
          ...passed,
        };
      }

      if (queryInfo.sort && queryInfo.sort.prop) {
        params["ordering"] =
          (queryInfo.sort.order == "descending" ? "-" : "") +
          queryInfo.sort.prop;
      }

      if (this.type) {
        params["type"] = this.type;
      }

      debounced(this, url, params);
    },
    onUploadBackground(uploadEvent) {
      const paths = uploadEvent.target.files;
      const self = this;

      if (paths && paths[0]) {
        const path = paths[0];
        self.rawEvent.image = path;
        const reader = new FileReader();

        reader.onload = (e) => {
          self.previewBg = e.target.result;
        };

        reader.readAsDataURL(path);
      }
    },
    onUploadLogo(uploadEvent) {
      const paths = uploadEvent.target.files;
      const self = this;

      if (paths && paths[0]) {
        const path = paths[0];
        self.rawEvent.logo = path;
        const reader = new FileReader();

        reader.onload = (e) => {
          self.previewLogo = e.target.result;
        };

        reader.readAsDataURL(path);
      }
    },
    complete: function () {
      const url = `${process.env.VUE_APP_BASE_HOST}/en/api/event/`;
      this.successMsg = "";
      this.serverErrors = [];

      axios
        .post(url, this.event, {
          headers: {
            "content-type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.successMsg = "Successfully created the event";
        })
        .catch((e) => {
          if (e.response.status !== 401 && e.response.status !== 403) {
            this.serverErrors = humanize(e.response.data);
          } else {
            this.serverErrors = [e.response.data.detail];
          }
        });
    },
  },
  data() {
    const self = this;
    let rwEvent = {};
    if (this.isEdit && this.rawEventEdit) {
      rwEvent = this.rawEventEdit;
    }

    return {
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() < new Date(self.rawEvent.start_date_time).getTime()
          );
        },
      },
      pickerOptionsPublish: {
        disabledDate(time) {
          return (
            time.getTime() <
            new Date(self.rawEvent.publish_start_date_time).getTime()
          );
        },
      },
      dirties: [],
      datePicker: null,
      formIndex: 1,
      rawEvent: rwEvent,
      serverErrors: [],
      successMsg: "",
      previewBg: null,
      previewLogo: null,
      value: "",
      options: [
        {
          value: "Organizer",
          label: "Organizer",
        },
        {
          value: "Admin",
          label: "Admin",
        },
        {
          value: "Support",
          label: "Support",
        },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      users: [],
      titles: [
        {
          prop: "first_name",
          label: "Name",
          formatter: (row) => {
            return row.first_name + " " + row.last_name;
          },
        },
        {
          prop: "phone_number",
          label: "Phone",
        },
      ],
      filters: [
        {
          value: "",
        },
      ],
    };
  },
  mounted() {
    this.loadData({});
  },
  mixins: [GetError, User],
};
</script>
<style lang="scss">
.form-event {
  display: flex;
  background: white;
  margin: 0;
}

.right-col {
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .location,
  .returns {
    margin-top: 60px;
  }
}

.form-navigation {
  text-align: right;
  button {
    margin: 0;
    margin-left: 15px;
  }
}

.event-branding,
.logo {
  .image-preview {
    margin-top: 10px;
    height: 162px;
    width: 285px;
    border: solid 1px;
  }
}

.token-value-summary {
  border: 1px solid #e3e3e3;
  border-radius: 30px;
  padding: 5px 18px;
  margin-bottom: 10px;
}

.add-vendor {
  margin-top: 20px;
}

.hint-label {
  font-family: Inter, sans-serif;
  font-size: 11px;
  color: #021b43;
  letter-spacing: 0.39px;
  line-height: 14px;
  margin-bottom: 5px;
  display: block;
  font-weight: 500;
}

.hint-small {
  font-family: Inter, sans-serif;
  font-size: 12px;
  color: #021b43;
}

.editing {
  .left-navigation {
    ul li {
      cursor: pointer;
    }
  }
}
</style>
